import React, {useState} from 'react';
import '../App.css';
import {  Link } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const handleLinkClick = () => {
        setIsOpen(false);
        window.scrollTo(0, 0);
    }
    return (
        <nav className="navbar"> 
            <div className="logo">
                {/* <h1>logo is here</h1> */}
            </div>
            <div className='navbar-links'>
                <ul className= {`navbar-menu ${isOpen ? "open" : ""}`}>
                    <li><Link to={"/home"} onClick={handleLinkClick}>Home</Link></li>
                    <li><Link to={"/services"} onClick={handleLinkClick}>Services</Link></li>
                    <li><Link to={"/contactUs"} onClick={handleLinkClick}>Contact</Link></li>
                    <li><Link to={"/gallery"} onClick={handleLinkClick}>Gallery</Link></li>
                    <li><Link to={"/aboutUs"} onClick={handleLinkClick}>About</Link></li>
                </ul>
            </div>
            <div className='hamburger-button' onClick={toggleMenu}>
                &#x2630;
            </div>
        </nav>
    )
}

export default Navbar